class GlobalStore {
  public isManualStopRecord: boolean;

  constructor() {
    this.isManualStopRecord = false;
  }
}

export const GlobalInstance = new GlobalStore();
